export default "__VITE_ASSET__CWRotKn0__"